// Comprehensive list of emoji icons suitable for services and categories
export const EMOJI_ICONS = [
  // Beauty & Wellness
  '💇‍♀️', '💇‍♂️', '💅', '💄', '🧴', '🛁', '🧖‍♀️', '🧖‍♂️', '💆‍♀️', '💆‍♂️', '🧘‍♀️', '🧘‍♂️',
  '🏃‍♀️', '🏃‍♂️', '🚶‍♀️', '🚶‍♂️', '🏊‍♀️', '🏊‍♂️', '🚴‍♀️', '🚴‍♂️', '🏋️‍♀️', '🏋️‍♂️',
  '💪', '🦵', '🦶', '👂', '👃', '👄', '👅', '👁️', '👀', '🧠', '🫀', '🫁',
  '🦴', '🦷', '🦿', '🦾', '💋',
  
  // Health & Medical
  '🏥', '⚕️', '🩺', '💊', '🩹', '🩻', '🧬', '🔬', '🧪', '💉',
  '🏨', '🏩', '🏪', '🏫', '🏬', '🏭', '🏯', '🏰', '💒', '⛪', '🕌', '🛕',
  '🕍', '⛩️', '🕋', '⛲', '⛺', '🌁', '🌃', '🏙️', '🌄', '🌅', '🌆', '🌇',
  '🌉', '♨️', '🎠', '🎡', '🎢', '💈', '🎪',
  
  // Tools & Services
  '🛠️', '🔧', '🔨', '⚙️', '🔩', '🪛', '🪜', '🪣', '🧰', '📦', '📋',
  '📁', '📂', '🗂️', '📅', '📆', '🗓️', '📇', '🗃️', '📌', '📍', '📎', '🖇️',
  '📏', '📐', '✂️', '🗄️', '🗑️', '🔒', '🔓', '🔏', '🔐', '🔑', '🗝️',
  
  // Technology
  '💻', '🖥️', '📱', '⌨️', '🖱️', '🖨️', '📡', '🔌', '💡', '🔋', '📺', '📷',
  '📹', '📼', '🔍', '🔎', '🕯️', '🔦', '🏮', '🪔', '📞', '📟', '📠',
  '📻', '🎙️', '🎚️', '🎛️', '🧭', '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳',
  '🖲️', '💽', '💾', '💿', '📀',
  
  // Food & Beverage
  '🍽️', '🍕', '🍔', '🍜', '🍣', '🍰', '☕', '🍺', '🍷', '🥤', '🍹', '🍸',
  '🍴', '🥄', '🔪', '🏺', '🍶', '🍾', '🍻', '🥂', '🥃', '🧃', '🥛', '🫖',
  '🧋', '🍵', '🧉', '🍼',
  
  // Education & Learning
  '📚', '✏️', '📝', '🎓', '🏫', '📖', '✒️', '🖊️', '📐', '🧮', '🔢',
  '📰', '📑', '🔖', '🏷️', '💰', '🪙', '💴', '💵', '💶', '💷',
  '📊', '📈', '📉', '🗒️',
  
  // Transportation
  '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐', '🚚', '🚛',
  '🚜', '🛴', '🚲', '🛵', '🏍️', '🛺', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡',
  '🚠', '🚟', '🚃', '🚋', '🚞', '🚝', '🚄', '🚅', '🚈', '🚂', '🚆', '🚇',
  '🚊', '🚉', '✈️', '🛫', '🛬', '🛩️', '💺', '🛰️', '🚀', '🛸', '🚁', '🛶',
  
  // Entertainment
  '🎬', '🎭', '🎨', '🎪', '🎯', '🎲', '🎮', '🎸', '🎹', '🎺', '🎻', '🥁',
  '🎤', '🎧', '🎼', '🎵', '🎶',
  
  // Business & Finance
  '💼', '💳', '🏦', '💱', '💲', '🏢', '📞', '📧', '📨', '📩', '📪', '📫',
  '📬', '📭', '📮', '🗳️',
  
  // Home & Garden
  '🏠', '🏡', '🏘️', '🏚️', '🏗️', '🏭', '🏢', '🏬', '🏣', '🏤', '🏥', '🏨',
  '🏩', '🏪', '🏫', '🏯', '🏰', '💒', '⛪', '🕌', '🛕', '🕍', '⛩️', '🕋',
  '⛲', '⛺', '🌁', '🌃', '🏙️', '🌄', '🌅', '🌆', '🌇', '🌉', '♨️',
  
  // Sports & Fitness
  '⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🏉', '🎱', '🏓', '🏸',
  '🏄‍♀️', '🏄‍♂️', '🚣‍♀️', '🚣‍♂️', '⛹️‍♀️', '⛹️‍♂️', '🚵‍♀️', '🚵‍♂️', '🏇', '🛷️', '⛷️', '🏂',
  '🏌️‍♀️', '🏌️‍♂️',
  
  // Nature & Outdoors
  '🌲', '🌳', '🌴', '🌵', '🌾', '🌿', '☘️', '🍀', '🍁', '🍂', '🍃', '🌺',
  '🌸', '💮', '🏵️', '🌹', '🥀', '🌻', '🌼', '🌷', '🌱',
  
  // Animals & Pets
  '🐕', '🐈', '🐎', '🐄', '🐖', '🐑', '🐐', '🐓', '🦆', '🦅', '🦉', '🦇',
  '🐺', '🐱', '🐈‍⬛', '🐅', '🐆', '🐴', '🫎', '🫏', '🐂', '🐃', '🐷', '🐗',
  '🐽', '🐏', '🐪', '🐫', '🦙', '🦒', '🐘', '🦣', '🦏', '🦛', '🐭', '🐁',
  '🐀', '🐹', '🐰', '🐇', '🐿️', '🦫',
  
  // Weather & Nature
  '☀️', '🌤️', '⛅', '🌥️', '☁️', '🌦️', '🌧️', '⛈️', '🌩️', '🌨️',
  
  // Time & Calendar
  '🕐', '🕑', '🕒', '🕓', '🕔', '🕕', '🕖', '🕗', '🕘', '🕙', '🕚', '🕛',
  '🕜', '🕝', '🕞', '🕟', '🕠', '🕡', '🕢', '🕣', '🕤', '🕥', '🕦', '🕧',
  '⏰', '⏱️', '⏲️', '🕰️', '⌛', '⏳', '📅', '📆', '🗓️',
  
  // Objects & Items
  '📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '💽', '💾', '💿', '📀',
  '🎥', '🎬', '📺', '📻', '📷', '📸', '📹', '📼', '🔍', '🔎', '🕯️', '💡',
  '🔦', '🏮', '🪔', '📞', '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '🧭',
  '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳', '📡', '🔋', '🔌',
  
  // Symbols & Shapes
  '⭐', '🌟', '✨', '💫', '⚡', '🔥', '💧', '🌊', '🌈', '🌙',
  '💎', '🔶', '🔷', '🔸', '🔹', '🔺', '🔻', '💠', '🔘', '🔴', '🟠', '🟡',
  '🟢', '🔵', '🟣', '⚫', '⚪', '🟤',
  
  // Food & Drinks Extended
  '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🍈', '🍒', '🍑',
  '🥭', '🍍', '🥥', '🥝', '🍅', '🥑', '🥦', '🥬', '🥒', '🌶️', '🫑', '🌽',
  '🥕', '🫒', '🧄', '🧅', '🥔', '🍠', '🥐', '🥯', '🍞', '🥖', '🥨', '🧀',
  '🥚', '🍳', '🧈', '🥞', '🧇', '🥓', '🥩', '🍗', '🍖', '🦴', '🌭', '🍔',
  
  // Activities & Hobbies
  '🎨', '🎭', '🎪', '🎯', '🎲', '🎮', '🎸', '🎹', '🎺', '🎻', '🥁', '🎤',
  '🎧', '🎼', '🎵', '🎶',
  
  // Travel & Places
  '🗺️', '🗽', '🗼', '🏰', '🏯', '🏛️', '⛪', '🕌', '🛕', '🕍', '⛩️', '🕋',
  '⛲', '⛺', '🌁', '🌃', '🏙️', '🌄', '🌅', '🌆', '🌇', '🌉', '♨️', '🎠',
  '🎡', '🎢', '💈', '🎪', '🚂', '🚃', '🚄', '🚅', '🚆', '🚇', '🚈', '🚉',
  '🚊', '🚝', '🚞', '🚋', '🚌', '🚍', '🚎', '🚐', '🚑', '🚒', '🚓', '🚔',
  
  // Communication
  '📞', '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '🎤', '🎧', '🎼', '🎵',
  '📧', '📨', '📩', '📪', '📫', '📬', '📭', '📮', '🗳️',
  
  // Miscellaneous & Fun
  '🎈', '🎉', '🎊', '🎋', '🎍', '🎎', '🎏', '🎐', '🎀', '🎁', '🎗️', '🎟️',
  '🎫', '🎖️', '🏆', '🏅', '🥇', '🥈', '🥉'
];

// Grouped emoji icons with headers for better organization
export const GROUPED_EMOJI_ICONS = [
  {
    title: "Beauty & Wellness",
    icons: ['💇‍♀️', '💇‍♂️', '💅', '💄', '🧴', '🛁', '🧖‍♀️', '🧖‍♂️', '💆‍♀️', '💆‍♂️', '🧘‍♀️', '🧘‍♂️', '🏃‍♀️', '🏃‍♂️', '🚶‍♀️', '🚶‍♂️', '🏊‍♀️', '🏊‍♂️', '🚴‍♀️', '🚴‍♂️', '🏋️‍♀️', '🏋️‍♂️', '💪', '🦵', '🦶', '👂', '👃', '👄', '👅', '👁️', '👀', '🧠', '🫀', '🫁', '🦴', '🦷', '🦿', '🦾', '💋']
  },
  {
    title: "Health & Medical",
    icons: ['🏥', '⚕️', '🩺', '💊', '🩹', '🩻', '🧬', '🔬', '🧪', '💉', '🏨', '🏩', '🏪', '🏫', '🏬', '🏭', '🏯', '🏰', '💒', '⛪', '🕌', '🛕', '🕍', '⛩️', '🕋', '⛲', '⛺', '🌁', '🌃', '🏙️', '🌄', '🌅', '🌆', '🌇', '🌉', '♨️', '🎠', '🎡', '🎢', '💈', '🎪']
  },
  {
    title: "Tools & Services",
    icons: ['🛠️', '🔧', '🔨', '⚙️', '🔩', '🪛', '🪜', '🪣', '🧰', '📦', '📋', '📁', '📂', '🗂️', '📅', '📆', '🗓️', '📇', '🗃️', '📌', '📍', '📎', '🖇️', '📏', '📐', '✂️', '🗄️', '🗑️', '🔒', '🔓', '🔏', '🔐', '🔑', '🗝️']
  },
  {
    title: "Technology",
    icons: ['💻', '🖥️', '📱', '⌨️', '🖱️', '🖨️', '📡', '🔌', '💡', '🔋', '📺', '📷', '📹', '📼', '🔍', '🔎', '🕯️', '🔦', '🏮', '🪔', '📞', '📟', '📠', '📻', '🎙️', '🎚️', '🎛️', '🧭', '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳', '🖲️', '💽', '💾', '💿', '📀']
  },
  {
    title: "Food & Beverage",
    icons: ['🍽️', '🍕', '🍔', '🍜', '🍣', '🍰', '☕', '🍺', '🍷', '🥤', '🍹', '🍸', '🍴', '🥄', '🔪', '🏺', '🍶', '🍾', '🍻', '🥂', '🥃', '🧃', '🥛', '🫖', '🧋', '🍵', '🧉', '🍼']
  },
  {
    title: "Education & Learning",
    icons: ['📚', '✏️', '📝', '🎓', '🏫', '📖', '✒️', '🖊️', '📐', '🧮', '🔢', '📰', '📑', '🔖', '🏷️', '💰', '🪙', '💴', '💵', '💶', '💷', '📊', '📈', '📉', '🗒️']
  },
  {
    title: "Transportation",
    icons: ['🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐', '🚚', '🚛', '🚜', '🛴', '🚲', '🛵', '🏍️', '🛺', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋', '🚞', '🚝', '🚄', '🚅', '🚈', '🚂', '🚆', '🚇', '🚊', '🚉', '✈️', '🛫', '🛬', '🛩️', '💺', '🛰️', '🚀', '🛸', '🚁', '🛶']
  },
  {
    title: "Entertainment",
    icons: ['🎬', '🎭', '🎨', '🎪', '🎯', '🎲', '🎮', '🎸', '🎹', '🎺', '🎻', '🥁', '🎤', '🎧', '🎼', '🎵', '🎶']
  },
  {
    title: "Business & Finance",
    icons: ['💼', '💳', '🏦', '💱', '💲', '🏢', '📞', '📧', '📨', '📩', '📪', '📫', '📬', '📭', '📮', '🗳️']
  },
  {
    title: "Home & Garden",
    icons: ['🏠', '🏡', '🏘️', '🏚️', '🏗️', '🏭', '🏢', '🏬', '🏣', '🏤', '🏥', '🏨', '🏩', '🏪', '🏫', '🏯', '🏰', '💒', '⛪', '🕌', '🛕', '🕍', '⛩️', '🕋', '⛲', '⛺', '🌁', '🌃', '🏙️', '🌄', '🌅', '🌆', '🌇', '🌉', '♨️']
  },
  {
    title: "Sports & Fitness",
    icons: ['⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🏉', '🎱', '🏓', '🏸', '🏄‍♀️', '🏄‍♂️', '🚣‍♀️', '🚣‍♂️', '⛹️‍♀️', '⛹️‍♂️', '🚵‍♀️', '🚵‍♂️', '🏇', '🛷️', '⛷️', '🏂', '🏌️‍♀️', '🏌️‍♂️']
  },
  {
    title: "Nature & Outdoors",
    icons: ['🌲', '🌳', '🌴', '🌵', '🌾', '🌿', '☘️', '🍀', '🍁', '🍂', '🍃', '🌺', '🌸', '💮', '🏵️', '🌹', '🥀', '🌻', '🌼', '🌷', '🌱']
  },
  {
    title: "Animals & Pets",
    icons: ['🐕', '🐈', '🐎', '🐄', '🐖', '🐑', '🐐', '🐓', '🦆', '🦅', '🦉', '🦇', '🐺', '🐱', '🐈‍⬛', '🐅', '🐆', '🐴', '🫎', '🫏', '🐂', '🐃', '🐷', '🐗', '🐽', '🐏', '🐪', '🐫', '🦙', '🦒', '🐘', '🦣', '🦏', '🦛', '🐭', '🐁', '🐀', '🐹', '🐰', '🐇', '🐿️', '🦫']
  },
  {
    title: "Weather & Nature",
    icons: ['☀️', '🌤️', '⛅', '🌥️', '☁️', '🌦️', '🌧️', '⛈️', '🌩️', '🌨️']
  },
  {
    title: "Time & Calendar",
    icons: ['🕐', '🕑', '🕒', '🕓', '🕔', '🕕', '🕖', '🕗', '🕘', '🕙', '🕚', '🕛', '🕜', '🕝', '🕞', '🕟', '🕠', '🕡', '🕢', '🕣', '🕤', '🕥', '🕦', '🕧', '⏰', '⏱️', '⏲️', '🕰️', '⌛', '⏳', '📅', '📆', '🗓️']
  },
  {
    title: "Objects & Items",
    icons: ['📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '💽', '💾', '💿', '📀', '🎥', '🎬', '📺', '📻', '📷', '📸', '📹', '📼', '🔍', '🔎', '🕯️', '💡', '🔦', '🏮', '🪔', '📞', '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '🧭', '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳', '📡', '🔋', '🔌']
  },
  {
    title: "Symbols & Shapes",
    icons: ['⭐', '🌟', '✨', '💫', '⚡', '🔥', '💧', '🌊', '🌈', '🌙', '💎', '🔶', '🔷', '🔸', '🔹', '🔺', '🔻', '💠', '🔘', '🔴', '🟠', '🟡', '🟢', '🔵', '🟣', '⚫', '⚪', '🟤']
  },
  {
    title: "Food & Drinks Extended",
    icons: ['🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🍈', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🥑', '🥦', '🥬', '🥒', '🌶️', '🫑', '🌽', '🥕', '🫒', '🧄', '🧅', '🥔', '🍠', '🥐', '🥯', '🍞', '🥖', '🥨', '🧀', '🥚', '🍳', '🧈', '🥞', '🧇', '🥓', '🥩', '🍗', '🍖', '🦴', '🌭', '🍔']
  },
  {
    title: "Activities & Hobbies",
    icons: ['🎨', '🎭', '🎪', '🎯', '🎲', '🎮', '🎸', '🎹', '🎺', '🎻', '🥁', '🎤', '🎧', '🎼', '🎵', '🎶']
  },
  {
    title: "Travel & Places",
    icons: ['🗺️', '🗽', '🗼', '🏰', '🏯', '🏛️', '⛪', '🕌', '🛕', '🕍', '⛩️', '🕋', '⛲', '⛺', '🌁', '🌃', '🏙️', '🌄', '🌅', '🌆', '🌇', '🌉', '♨️', '🎠', '🎡', '🎢', '💈', '🎪', '🚂', '🚃', '🚄', '🚅', '🚆', '🚇', '🚈', '🚉', '🚊', '🚝', '🚞', '🚋', '🚌', '🚍', '🚎', '🚐', '🚑', '🚒', '🚓', '🚔']
  },
  {
    title: "Communication",
    icons: ['📞', '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '🎤', '🎧', '🎼', '🎵', '📧', '📨', '📩', '📪', '📫', '📬', '📭', '📮', '🗳️']
  },
  {
    title: "Miscellaneous & Fun",
    icons: ['🎈', '🎉', '🎊', '🎋', '🎍', '🎎', '🎏', '🎐', '🎀', '🎁', '🎗️', '🎟️', '🎫', '🎖️', '🏆', '🏅', '🥇', '🥈', '🥉']
  }
];

